import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Routing, Clear } from '../icons/index';
import Paper from '@material-ui/core/Paper';

const MENU_SIZE = 40;

const styles = (theme) => ({
	text: {},
	icon: {},
	contextMenu: {
		paddingRight: '15px',
		padding: '5px',
		fontSize: '0.8em',
		backgroundColor: 'rgba(255, 255, 255, 0.9)',
		position: 'absolute',
		justifyContent: 'space-between',
	},
	buttonIcon: {
		border: '2px #00264A solid',
		backgroundColor: '#fffff',
		color: '#00264A',
		fontSize: '18px',
		padding: '2px 0px',
		minWidth: '38px',
		'&:hover': {
			backgroundColor: theme.palette.action.hover,
			color: theme.palette.action.hoverText,
		},
	},
	button: {
		backgroundColor: '#a20808',
		color: '#fff',
		width: '72%',
		fontSize: '0.8rem',
		'&:hover': {
			backgroundColor: theme.palette.action.hover,
			color: theme.palette.action.hoverText,
		},
		padding: '0 6px',
	},
	text: {
		color: theme.palette.gray,
	},
});

const renderItems = function ({ items, clickHandler, position, classes }) {
	var key = 0;

	return items.map((item) => {
		const { id, name } = item;

		return (
			<Button
				key={key++}
				className={item.id === 'delete_feature' ? classes.buttonIcon : classes.button}
				onClick={(ev) => {
					clickHandler(ev, position, item);
				}}>
				<div style={{ float: 'left' }}>
					{item.id === 'delete_feature' ? (
						<Clear style={{ width: 'auto' }} viewBox='4 4 24 24' />
					) : (
						<Routing
							style={{ width: 'auto', marginRight: '6px' }}
							viewBox='12 8 26 26'
						/>
					)}
				</div>
				{item.id !== 'delete_feature' ? item.name : ''}
			</Button>
		);
	});
};

var clickOutsideFunc = null;

document.addEventListener('click', function (event) {
	var container = document.getElementById('contextmenu');
	if (
		container !== event.target &&
		!container.contains(event.target) &&
		clickOutsideFunc !== null
	) {
		clickOutsideFunc();
	}
});

const ContextMenu = ({
	items,
	clickHandler,
	position,
	classes,
	title,
	coords,
	coordsLKS,
	autoHeight,
	isRoutingAllowed,
	clickOutside,
}) => {
	clickOutsideFunc = clickOutside;

	if (window.innerWidth - position[0] < MENU_SIZE) {
		var x = position[0] - MENU_SIZE;
		var reverse = true;
	} else {
		var reverse = false;
		var x = position !== null ? position[0] : 0;
	}

	items.reverse();

	return (
		<Paper
			id='contextmenu'
			className={classes.contextMenu}
			style={{
				left: x,
				borderRadius: 0,
				top: position !== null ? position[1] : 0,
				display: position.length > 0 ? 'flex' : 'none',
				maxWidth: '180px',
				minWidth: '40px',
				padding: '10px 22px 10px 6px',
				flexDirection: reverse ? 'row-reverse' : 'column',
      }}>
      <div style={{display: 'flex', fontSize: '120%', fontWeight: 'bolder', paddingBottom: '10px'}}>
			{title}
      </div>
      
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				{renderItems({ items, clickHandler, position, classes })}
			</div>
		</Paper>
	);
};

ContextMenu.propTypes = {
	autoHeight: PropTypes.bool,
	items: PropTypes.array.isRequired, //{name: '', id: '', disabled: bool}
	clickHandler: PropTypes.func.isRequired,
	position: PropTypes.array,
	classes: PropTypes.object.isRequired,
	title: PropTypes.string,
	isRoutingAllowed: PropTypes.bool,
};

export default withStyles(styles)(ContextMenu);
